import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import Main from "./components/Views/Main/Main";
import Hyper from "./Theme/Hyper";
import { DataProvider } from "./contexts/DataContext";
import { UIProvider } from "./contexts/UIContext";
import { SocketProvider } from "./contexts/SocketContext";
import Teams from "./components/Views/Teams";
import Seasons from "./components/Views/Seasons";
import Fixtures from "./components/Views/Fixtures";
import Fixture from "./components/Fixture/Fixture";
import Players from "./components/Views/Players";
import Transfers from "./components/Views/Transfers";
import Countries from "./components/Views/Countries";
import Officials from "./components/Views/Officials";
import Stadiums from "./components/Views/Stadiums";
import Users from "./components/Views/Users";
import Logs from "./components/Views/Logs";
import Opta from "./components/Views/Opta";
import Monitoring from "./components/Views/Monitoring";
import Login from "./components/Authentication/Login";
import { UserContext, UserProvider } from "./contexts/UserContext";
import Database from "./components/Views/Database";
import Config from "./components/Views/Config";
import OPTAViewer from "./components/Views/OPTAViewer";
import Competitions from "./components/Views/Competitions";
import Formations from "./components/Views/Formations";
import Settings from "./components/Views/Settings";
import gql from "graphql-tag";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  useQuery,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    },
  };
});

const httpLink = createHttpLink({
  uri:
    (window.ENV?.REACT_APP_PROJECT_SERVER ||
      process.env.REACT_APP_PROJECT_SERVER) + "/graphql",
});

const user_client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const LOGGED_IN = gql`
  query LoggedIn {
    me {
      username
      token
    }
  }
`;
function App() {
  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <ThemeProvider theme={Hyper}>
          <UserProvider>
            <UIProvider>
              <DataProvider>
                <SocketProvider>
                  <Routes />
                </SocketProvider>
              </DataProvider>
            </UIProvider>
          </UserProvider>
        </ThemeProvider>
      </Router>
    </div>
  );
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
window.hideHeader = getParameterByName("show_header") === "false";
function Routes() {
  const { user, setUserToken } = useContext(UserContext);
  const {
    loading,
    error,
    data,
    refetch: refetchLogin,
  } = useQuery(LOGGED_IN, {
    fetchPolicy: "network-first",
    client: user_client,
  });

  useEffect(() => {
    if (data) {
      setUserToken(data?.me?.token);
    }
  }, [data]);

  return (
    <>
      {!data?.me?.token && (
        <Login
          loggedIn={() => {
            refetchLogin();
          }}
        />
      )}
      {data?.me?.token && (
        <Switch>
          <Route exact path="/">
            <Redirect to="/gaa/fixtures" />
          </Route>
          <Route path="/gaa/teams">
            <Main>
              <Teams />
            </Main>
          </Route>
          <Route path="/gaa/players">
            <Main>
              <Players />
            </Main>
          </Route>
          <Route path="/gaa/fixtures/:fixtureId">
            <Main>
              <Fixture />
            </Main>
          </Route>
          <Route path="/gaa/fixtures">
            <Main>
              <Fixtures />
            </Main>
          </Route>
          <Route path="/season/:season">
            <Main>
              <Fixtures />
            </Main>
          </Route>
          <Route path="/gaa/competitions">
            <Main>
              <Competitions />
            </Main>
          </Route>
          <Route path="/competition/:comp">
            <Main>
              <Seasons />
            </Main>
          </Route>
          <Route path="/gaa/seasons">
            <Main>
              <Seasons />
            </Main>
          </Route>
          <Route path="/gaa/countries">
            <Main>
              <Countries />
            </Main>
          </Route>
          {/* <Route path="/football/formations">
            <Main>
              <Formations />
            </Main>
          </Route> */}
          <Route path="/gaa/officials">
            <Main>
              <Officials />
            </Main>
          </Route>
          <Route path="/gaa/stadiums">
            <Main>
              <Stadiums />
            </Main>
          </Route>
          <Route path="/system/opta">
            <Main>
              <Opta />
            </Main>
          </Route>
          <Route path="/system/monitoring">
            <Main>
              <Monitoring />
            </Main>
          </Route>
          <Route path="/system/users">
            <Main>
              <Users />
            </Main>
          </Route>
          <Route path="/system/logs">
            <Main>
              <Logs />
            </Main>
          </Route>
          <Route path="/system/database">
            <Main>
              <Database />
            </Main>
          </Route>
          <Route path="/system/config">
            <Main>
              <Config />
            </Main>
          </Route>
          <Route path="/system/settings">
            <Main>
              <Settings />
            </Main>
          </Route>
          <Route path="/OptaViewer">
            <OPTAViewer />
          </Route>
          <Route path="/gaa">
            <Redirect to="/GAA/fixtures" />
          </Route>
        </Switch>
      )}
    </>
  );
}
export default App;
